/**
 * Canonical representations shared across the app.
 *
 * Seats: 0=N, 1=E, 2=S, 3=W (clockwise). The human always sits South (2).
 * Cards: card = suit*13 + rank, suit 0=♠ 1=♥ 2=♦ 3=♣, rank 0='2' … 12='A'.
 * Calls: a single number 0..37 (the pgx/OpenSpiel action space):
 *   0=Pass, 1=Double(X), 2=Redouble(XX), 3..37 = bids where
 *   bid action = 3 + (level-1)*5 + strain, strain 0=♣ 1=♦ 2=♥ 3=♠ 4=NT.
 */
export const SEATS = [0, 1, 2, 3];
export const SEAT_NAMES = ['N', 'E', 'S', 'W'];
export const SUIT_SYMBOLS = ['♠', '♥', '♦', '♣'];
export const RANK_CHARS = ['2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K', 'A'];
export const CARD_VALUES = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
export const STRAIN_SYMBOLS = ['♣', '♦', '♥', '♠', 'NT'];
export const STRAIN_LETTERS = ['C', 'D', 'H', 'S', 'N'];
export const PASS = 0;
export const DOUBLE = 1;
export const REDOUBLE = 2;
export const BID_OFFSET = 3;
export function cardSuit(card) {
    return Math.floor(card / 13);
}
export function cardRank(card) {
    return card % 13;
}
export function makeCard(suit, rank) {
    return suit * 13 + rank;
}
export function cardName(card) {
    return SUIT_SYMBOLS[cardSuit(card)] + RANK_CHARS[cardRank(card)];
}
export function cardToData(card) {
    return {
        id: card,
        value: CARD_VALUES[cardRank(card)],
        suit: cardSuit(card),
    };
}
export function cardFromData(data) {
    if (!Number.isInteger(data.id) || data.id < 0 || data.id >= 52) {
        throw new RangeError(`Invalid card id: ${data.id}`);
    }
    const card = data.id;
    const expected = cardToData(card);
    if (data.value !== expected.value || data.suit !== expected.suit) {
        throw new RangeError(`Card data does not match id ${data.id}`);
    }
    return card;
}
export function isBid(call) {
    return call >= BID_OFFSET;
}
export function bidLevel(call) {
    return Math.floor((call - BID_OFFSET) / 5) + 1;
}
export function bidStrain(call) {
    return ((call - BID_OFFSET) % 5);
}
export function makeBid(level, strain) {
    return BID_OFFSET + (level - 1) * 5 + strain;
}
export function callName(call) {
    if (call === PASS)
        return 'Pass';
    if (call === DOUBLE)
        return 'X';
    if (call === REDOUBLE)
        return 'XX';
    return `${bidLevel(call)}${STRAIN_SYMBOLS[bidStrain(call)]}`;
}
export function partnerOf(seat) {
    return ((seat + 2) % 4);
}
export function nextSeat(seat) {
    return ((seat + 1) % 4);
}
export function sameSide(a, b) {
    return a % 2 === b % 2;
}
export function isVulnerable(seat, vul) {
    return seat % 2 === 0 ? vul.ns : vul.ew;
}
//# sourceMappingURL=types.js.map